module.exports = __webpack_public_path__ + "admin-thumbs/s-speakers-carousel.png";